import React from 'react'
import UserVideoCall from '../../components/UserVideoCall/UserVideoCall'

function UserVideoCallPage() {
  return (
    <UserVideoCall/>
  )
}

export default UserVideoCallPage